import React, { FC, useState } from 'react';
import styles from './styles.module.css';
import Button from '../../Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationCircle,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import Modal from '../../Modal';
import { useGetCalcAllocationStatusQuery } from '../../../../api/carAllocationApi';
import { format } from 'date-fns';

export type AbortedProps = {
  onAbortedUpdate?: () => void;
  onAbortedCancel?: () => void;
};
const Aborted: FC<AbortedProps> = ({
  onAbortedUpdate,
  onAbortedCancel,
}: AbortedProps) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const { data: status } = useGetCalcAllocationStatusQuery();
  const failedDay = status && status.failedDay && new Date(status.failedDay);
  const lastApplicableDay =
    status && status.lastApplicableDay != null
      ? new Date(status.lastApplicableDay)
      : null;
  const onConfirm = () => setIsConfirmModalOpen(true);
  const onConfirmClose = () => setIsConfirmModalOpen(false);
  const onRefresh = () => {
    onConfirmClose();
    onAbortedUpdate?.();
  };
  const onCancel = () => {
    onConfirmClose();
    onAbortedCancel?.();
  };
  return (
    <>
      <hr className={styles.alertColorBar} />
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <FontAwesomeIcon icon={faXmark} className={styles.icCross} />
          <span className={styles.controlText}>計算が中断されました</span>
        </div>
        {onAbortedUpdate && onAbortedCancel && (
          <Button onClick={onConfirm} variants={['contain']}>
            確認する
          </Button>
        )}
        {isConfirmModalOpen && failedDay && (
          <Modal onRequestClose={onConfirmClose}>
            <div className={styles.modalHead}>計算が中断されました</div>
            <div className={styles.modalContent}>
              {lastApplicableDay ? (
                <>
                  <div className={styles.modalText}>
                    <div>
                      {format(failedDay, 'M/d')}分の配車ができませんでした。
                    </div>
                    <div>
                      {format(lastApplicableDay, 'M/d')}
                      までの配車表を更新してよろしいでしょうか？
                    </div>
                  </div>
                  <div className={styles.errorText}>
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={styles.icon}
                    />
                    更新すると、{format(failedDay, 'M/d')}
                    以降の配車表は削除されます
                  </div>
                  <div className={styles.buttons}>
                    <div className={styles.button}>
                      <Button variants={['fit', 'cancel']} onClick={onCancel}>
                        計算前に戻る
                      </Button>
                    </div>
                    <div className={styles.button}>
                      <Button variants={['fit']} onClick={onRefresh}>
                        更新する
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.modalText}>
                    <div>
                      {format(failedDay, 'M/d')}
                      分の配車ができませんでした。
                      <br />
                      契約情報を確認してください。
                    </div>
                  </div>
                  <div className={styles.buttons}>
                    <div className={styles.button}>
                      <Button variants={['fit', 'cancel']} onClick={onCancel}>
                        計算前に戻る
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default Aborted;
